
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class DownloadFileInfoModel extends Model<DownloadFileInfoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'blobPath', type: 'string' },
		{ name: 'fullFilePath', type: 'string' },
		{ name: 'downloadUrl', type: 'string' }
	];
	[key: string]: any;
	
	public blobPath: string;
	public fullFilePath: string;
	public downloadUrl: string;
    
	constructor(){
		super();
		this.blobPath = '';
		this.fullFilePath = '';
		this.downloadUrl = '';
		
	}
	getProperties(){
		return DownloadFileInfoModel.classProperties;
	}
}

